import _debounce from 'lodash/debounce';

export default (fn, leading = true) =>
  _debounce(fn, 300, {
    leading,
    trailing: !leading
  });
